import * as React from 'react';
import { Loader, LoaderSize, LoaderTheme } from '../Loader/Loader';
const { default: noDataImg } = require('../../../assets/images/projects/no_data.png');

type NoDataChartProps = {
    data: [] | null | undefined,
    emptyRows?: number
}

const NoDataChart = ({ data, emptyRows = 4 }: NoDataChartProps) => {
    const rows = Array(emptyRows).fill(1);
    return (
        <div className="no-data-chart">
            {(data === null || data === undefined) ?
                <Loader theme={LoaderTheme.Dark} size={LoaderSize.Medium} /> :
                <div className="no-data-chart_body">
                    <table className="no-data-chart_body_bg">
                        <tbody>
                            {rows.map((row, index) => {
                                return <tr key={index}>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>;
                            })}
                        </tbody>
                    </table>

                    <div className="no-data-chart_placeholder">
                        <img src={noDataImg} />
                        <div> Not enough data</div>
                    </div>
                </div>}
        </div>
    );
}

export default NoDataChart;